import React,{Component,useState,useEffect} from 'react'
import './Chat.css'
import queryString from 'query-string'
import io from 'socket.io-client'
import InfoBar from '../InfoBar/InfoBar'
import Input from '../Input/Input'
import Messages from '../Messages/Messages'

let socket

const Chat = ({location}) => {
    const [name,setName] = useState('')
    const [room,setRoom] = useState('')
    const [message,setMessage] = useState('')
    const [messages,setMessages] = useState([])
    const [users,setUsers] = useState([])
    const ENDPOINT = "https://chat-app-vash.herokuapp.com/"

    useEffect(() => {
        const {name, room} = queryString.parse(location.search)
        setName(name)
        setRoom(room)

        socket = io(ENDPOINT)

        socket.emit('join',[name, room],(error)=>{
            if(error)
            {
                window.alert("Existing User")
                window.location.href = '/'
            }
        })
        socket.on('roomData',users=>setUsers(users))
        //Unmounting
        return ()=>{
            socket.emit('disconnect')
            socket.off()
        }
    }, [location.search, ENDPOINT])

    useEffect(() => {
        socket.on('message',(message)=>{
            setMessages([...messages,message])
        })
    }, [messages])

    const sendMessage = (e) => {
        e.preventDefault()
        if(message)
        socket.emit('sendMessage',message)
        setMessage('')
    }

    const openNav = () => {
        document.getElementById("mySidenav").style.width = "250px";
    }

    const closeNav = () => {
        document.getElementById("mySidenav").style.width = "0";
    }

    useEffect(() => {
        console.log("haii")
        socket.on('roomData',users=>console.log(users))
    },[users])

    console.log(users)


    return(
        <div style={{backgroundColor:'#1A1A1D'}}>
        <button class="button" style={{verticalAlign:'middle'}} onClick={openNav}><span>View Users</span></button>
        <i className="fa fa-arrow-circle-right"></i>
            <div id="mySidenav" class="sidenav">
            <a href="javascript:void(0)" class="closebtn" onClick={closeNav}>&times;</a>
                {users.map(user=><a>{user.name}</a>)}
            </div>

        <div className="outerContainer">
            <div className="container">
                <InfoBar room={room}/> 
                <Messages messages={messages} name={name}/>
                <Input message={message}
                setMessage={setMessage}
                sendMessage={sendMessage}/> 
                </div>
        </div>
        </div>
    )
}

export default Chat